import { connect } from 'react-redux'
import { loadData, rentElement, clearErrors } from '../../../../actions/warehouse_rent_list_actions'
import { RentList, Element, RentItem } from './warehouse_rent_list_types'

interface StateProps {
  warehouseRentList: RentList | null
  groupedAvailableElements: Record<string, Element[]>
  elementGroups: Record<string, string>
  rentElementRequestInProgress: boolean
  rentedItems: Record<string, any>
  errors: string[]
}

interface OwnProps {
  warehouseId: number
  isOverview?: boolean
  initialWarehouseRentList?: RentList | null
  initialRentedItems?: Record<string, RentItem[]> | null
}

interface DispatchProps {
  loadData: (data: any) => void
  rentElement: (rentListId: number, elementId: number, warehouseId: number, quantity: number) => void
  clearErrors: () => void
}

function mapStateToProps(state: any, props: OwnProps): StateProps {
  return {
    warehouseRentList: state.warehouseRentList.rentList,
    groupedAvailableElements: state.warehouseRentList.groupedAvailableElements,
    elementGroups: state.warehouseRentList.elementGroups,
    rentElementRequestInProgress: state.warehouseRentList.rentElementRequestInProgress,
    rentedItems: state.warehouseRentList.rentedItems,
    errors: state.warehouseRentList.errors,
  }
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return {
    loadData: (data) => dispatch(loadData(data)),
    rentElement: (rentListId, elementId, warehouseId, quantity) =>
      dispatch(rentElement(rentListId, elementId, warehouseId, quantity)),
    clearErrors: () => dispatch(clearErrors()),
  }
}

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps, mapDispatchToProps)
